var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.6164,
    cy: 28.6164,
    r: 21.6164,
    fill: "#FBD904",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.3391 27.3386L34.7094 33.9683C34.4194 34.2585 34.0752 34.4887 33.6962 34.6458C33.3172 34.8029 32.911 34.8838 32.5008 34.8838C32.0906 34.8838 31.6843 34.8029 31.3054 34.6458C30.9264 34.4887 30.5821 34.2585 30.2922 33.9683L23.6609 27.3386C21.9129 25.5904 20.7224 23.3631 20.2401 20.9384C19.7579 18.5136 20.0055 16.0003 20.9516 13.7163C21.8977 11.4323 23.4998 9.48007 25.5554 8.10658C27.611 6.7331 30.0278 6 32.5 6C34.9722 6 37.389 6.7331 39.4446 8.10658C41.5002 9.48007 43.1023 11.4323 44.0484 13.7163C44.9945 16.0003 45.2421 18.5136 44.7599 20.9384C44.2776 23.3631 43.0871 25.5904 41.3391 27.3386V27.3386Z",
    stroke: "#434343",
    strokeWidth: 3.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8146 21.8141C36.6936 20.935 37.1875 19.7427 37.1875 18.4995C37.1875 17.2563 36.6936 16.064 35.8146 15.1849C34.9355 14.3059 33.7432 13.812 32.5 13.812C31.2568 13.812 30.0645 14.3059 29.1854 15.1849C28.3064 16.064 27.8125 17.2563 27.8125 18.4995C27.8125 19.7427 28.3064 20.935 29.1854 21.8141C30.0645 22.6931 31.2568 23.187 32.5 23.187C33.7432 23.187 34.9355 22.6931 35.8146 21.8141Z",
    stroke: "#FBD904",
    strokeWidth: 3.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.49f964c08171f7480b7dccca81b596e1.svg";
export { ForwardRef as ReactComponent };